import axios from '../plugins/axios'

const getEvaluated = id => axios.get(`/evaluated/${id}`)
const searchEvaluated = (companyId, typeDocument, documentId) =>
  axios.get(`/evaluated/${typeDocument}/${documentId}/company/${companyId}`)
const createEvaluated = evaluated => axios.post('/evaluated', evaluated)
const updateEvaluated = evaluated => axios.put('/evaluated', evaluated)

export { getEvaluated, createEvaluated, searchEvaluated, updateEvaluated }
